/**
 * Get the physical configuration data, which is metadata (id/label) for
 * different kinds of physical media, eg. CD, LP, Cassette, etc.
 */
export default (): string => '/api/physical/configurations';
